<div class="instance-container">
    <div class="title">
        <fa-icon [icon]="faAngleRight"></fa-icon>
        <span>{{ 'Instance.Title' | translate }}</span>
    </div>

    <div class="content">
        <form [formGroup]="instanceForm" (ngSubmit)="onSubmit()">
            <div class="form-content">
                <mat-card appearance="outlined" class="box default-card">
                    <mat-card-content>
                        <div>
                            <mat-form-field>
                                <mat-label>{{ 'Instance.Display' | translate }}</mat-label>
                                <input matInput formControlName="display" autocomplete="off" />
                            </mat-form-field>
                        </div>

                        <div>
                            <mat-form-field>
                                <mat-label>{{ 'Instance.Domain' | translate }}</mat-label>
                                <input matInput formControlName="domain" autocomplete="off" />
                            </mat-form-field>
                        </div>

                        <div>
                            <mat-form-field>
                                <mat-label>{{ 'Instance.Proxy' | translate }}</mat-label>
                                <input matInput formControlName="proxy" autocomplete="off" />
                            </mat-form-field>
                        </div>

                        <div>
                            <mat-form-field>
                                <mat-label>{{ 'Instance.Phone' | translate }}</mat-label>
                                <input matInput formControlName="phone" [matAutocomplete]="autoPhone" />
                                <mat-autocomplete #autoPhone="matAutocomplete" (optionSelected)="phoneChange($event)">
                                    @for (sda of sdas | async; track sda) {
                                    <mat-option [value]="sda.number">
                                        {{ sda.number }}
                                    </mat-option>
                                    }
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>

                        <div>
                            <mat-form-field>
                                <mat-label>{{ 'Instance.Receptionist' | translate }}</mat-label>
                                <input matInput formControlName="receptionist" [matAutocomplete]="autoReceptionist" />
                                <mat-autocomplete #autoReceptionist="matAutocomplete" [displayWith]="displayReceptionist" (optionSelected)="receptionistChange($event)">
                                    @for (extension of numberExtensions | async; track extension) {
                                    <mat-option [value]="extension.number">{{ extension.number }} ({{ extension.name }})</mat-option>
                                    }
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>

                        <div>
                            <mat-form-field>
                                <mat-label>{{ 'Instance.Voicemail' | translate }}</mat-label>
                                <input matInput formControlName="voicemail" [matAutocomplete]="autoVoicemail" />
                                <mat-autocomplete #autoVoicemail="matAutocomplete" (optionSelected)="voicemailChange($event)">
                                    @for (extension of voicemailExtensions | async; track extension) {
                                    <mat-option [value]="extension.number">
                                        {{ extension.number }}
                                    </mat-option>
                                    }
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>

                        <mat-card>
                            <mat-card-header>
                                <mat-card-title>{{ 'Instance.APIs' | translate }}</mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <div>
                                    <mat-form-field>
                                        <mat-label>{{ 'Instance.ExtensionsUrl' | translate }}</mat-label>
                                        <input matInput formControlName="extensionsUrl" (ngModelChange)="urlChange('extensions')" autocomplete="off" />
                                        @if (!instanceForm.get('extensionsUrl').valid) {
                                        <mat-error>
                                            {{ instanceForm.get('extensionsUrl').errors?.statusText }}
                                        </mat-error>
                                        }
                                        <button matSuffix mat-icon-button type="button" matTooltip="{{ 'Instance.CheckUrlTooltip' | translate }}" (click)="checkUrl('extensions')">
                                            <mat-icon>verified_user</mat-icon>
                                        </button>
                                    </mat-form-field>
                                    @if (extensionsUrlIsValid === false) {
                                    <mat-icon class="invalid-icon">close</mat-icon>
                                    } @else if (extensionsUrlIsValid === true){
                                    <mat-icon class="valid-icon">check</mat-icon>
                                    }
                                </div>

                                <div>
                                    <mat-form-field>
                                        <mat-label>{{ 'Instance.ProvisionningUrl' | translate }}</mat-label>
                                        <input matInput formControlName="provisionningUrl" (ngModelChange)="urlChange('provisionning')" autocomplete="off" />
                                        @if (!instanceForm.get('provisionningUrl').valid) {
                                        <mat-error>
                                            {{ instanceForm.get('provisionningUrl').errors?.statusText }}
                                        </mat-error>
                                        }
                                        <button
                                            matSuffix
                                            mat-icon-button
                                            type="button"
                                            matTooltip="{{ 'Instance.CheckUrlTooltip' | translate }}"
                                            (click)="checkUrl('provisionning')">
                                            <mat-icon>verified_user</mat-icon>
                                        </button>
                                    </mat-form-field>
                                    @if (provisionningUrlIsValid === false) {
                                    <mat-icon class="invalid-icon">close</mat-icon>
                                    } @else if (provisionningUrlIsValid === true){
                                    <mat-icon class="valid-icon">check</mat-icon>
                                    }
                                </div>

                                <div>
                                    <mat-form-field>
                                        <mat-label>{{ 'Instance.VoiceUrl' | translate }}</mat-label>
                                        <input matInput formControlName="voiceUrl" (ngModelChange)="urlChange('voice')" autocomplete="off" />
                                        @if (!instanceForm.get('voiceUrl').valid) {
                                        <mat-error>
                                            {{ instanceForm.get('voiceUrl').errors?.statusText }}
                                        </mat-error>
                                        }
                                        <button matSuffix mat-icon-button type="button" matTooltip="{{ 'Instance.CheckUrlTooltip' | translate }}" (click)="checkUrl('voice')">
                                            <mat-icon>verified_user</mat-icon>
                                        </button>
                                    </mat-form-field>
                                    @if (voiceUrlIsValid === false) {
                                    <mat-icon class="invalid-icon">close</mat-icon>
                                    } @else if (voiceUrlIsValid === true){
                                    <mat-icon class="valid-icon">check</mat-icon>
                                    }
                                </div>

                                <div>
                                    <mat-form-field>
                                        <mat-label>{{ 'Instance.SmsUrl' | translate }}</mat-label>
                                        <input matInput formControlName="smsUrl" (ngModelChange)="urlChange('sms')" autocomplete="off" />
                                        @if (!instanceForm.get('smsUrl').valid) {
                                        <mat-error>
                                            {{ instanceForm.get('smsUrl').errors?.statusText }}
                                        </mat-error>
                                        }
                                        <button matSuffix mat-icon-button type="button" matTooltip="{{ 'Instance.CheckUrlTooltip' | translate }}" (click)="checkUrl('sms')">
                                            <mat-icon>verified_user</mat-icon>
                                        </button>
                                    </mat-form-field>
                                    @if (smsUrlIsValid === false) {
                                    <mat-icon class="invalid-icon">close</mat-icon>
                                    } @else if (smsUrlIsValid === true){
                                    <mat-icon class="valid-icon">check</mat-icon>
                                    }
                                </div>

                                <div>
                                    <mat-form-field>
                                        <mat-label>{{ 'Instance.AudioUrl' | translate }}</mat-label>
                                        <input matInput formControlName="audioUrl" (ngModelChange)="urlChange('audio')" autocomplete="off" />
                                        @if (!instanceForm.get('audioUrl').valid) {
                                        <mat-error>
                                            {{ instanceForm.get('audioUrl').errors?.statusText }}
                                        </mat-error>
                                        }
                                        <button matSuffix mat-icon-button type="button" matTooltip="{{ 'Instance.CheckUrlTooltip' | translate }}" (click)="checkUrl('audio')">
                                            <mat-icon>verified_user</mat-icon>
                                        </button>
                                    </mat-form-field>
                                    @if (audioUrlIsValid === false) {
                                    <mat-icon class="invalid-icon">close</mat-icon>
                                    } @else if (audioUrlIsValid === true){
                                    <mat-icon class="valid-icon">check</mat-icon>
                                    }
                                </div>

                                <div>
                                    <mat-form-field>
                                        <mat-label>{{ 'Instance.MailUrl' | translate }}</mat-label>
                                        <input matInput formControlName="mailUrl" (ngModelChange)="urlChange('mail')" autocomplete="off" />
                                        @if (!instanceForm.get('mailUrl').valid) {
                                        <mat-error>
                                            {{ instanceForm.get('mailUrl').errors?.statusText }}
                                        </mat-error>
                                        }
                                        <button matSuffix mat-icon-button type="button" matTooltip="{{ 'Instance.CheckUrlTooltip' | translate }}" (click)="checkUrl('mail')">
                                            <mat-icon>verified_user</mat-icon>
                                        </button>
                                    </mat-form-field>
                                    @if (mailUrlIsValid === false) {
                                    <mat-icon class="invalid-icon">close</mat-icon>
                                    } @else if (mailUrlIsValid === true){
                                    <mat-icon class="valid-icon">check</mat-icon>
                                    }
                                </div>
                            </mat-card-content>
                        </mat-card>

                        <mat-card>
                            <mat-card-header>
                                <mat-card-title>{{ 'Features.Title' | translate }}</mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <mat-list>
                                    <mat-list-item>
                                        <mat-slide-toggle formControlName="feature_VM" (change)="featureSelectionChange()"></mat-slide-toggle>
                                        <mat-label>{{ 'Features.VM' | translate }}</mat-label>
                                    </mat-list-item>

                                    <mat-list-item>
                                        <mat-slide-toggle formControlName="feature_VM_MAIL" (change)="featureSelectionChange()"></mat-slide-toggle>
                                        <mat-label>{{ 'Features.VM_MAIL' | translate }}</mat-label>
                                    </mat-list-item>

                                    <mat-list-item>
                                        <mat-slide-toggle formControlName="feature_VM_SMS" (change)="featureSelectionChange()"></mat-slide-toggle>
                                        <mat-label>{{ 'Features.VM_SMS' | translate }}</mat-label>
                                    </mat-list-item>

                                    <mat-list-item>
                                        <mat-slide-toggle formControlName="feature_VM_TRANSCRIPT" (change)="featureSelectionChange()"></mat-slide-toggle>
                                        <mat-label>{{ 'Features.VM_TRANSCRIPT' | translate }}</mat-label>
                                    </mat-list-item>
                                </mat-list>
                            </mat-card-content>
                        </mat-card>
                    </mat-card-content>
                </mat-card>
            </div>

            <div class="save-button" [hidden]="!isInitialized">
                <button mat-raised-button color="accent" type="submit" [disabled]="!instanceForm.valid || !usersService.hasRight('Centrex-Add')">
                    {{ 'Instance.Apply' | translate }}
                </button>
            </div>

            <div class="save-button" [hidden]="isInitialized">
                <button mat-raised-button color="accent" type="submit" [disabled]="!instanceForm.valid || !usersService.hasRight('Centrex-Add')">
                    {{ 'Instance.Create' | translate }}
                </button>
            </div>
        </form>
    </div>
</div>
